import { NgModule } from '@angular/core';
import { AuthRoutingModule } from './auth-routing.module';
import { AuthComponent } from './auth.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '@shared/shared.module';
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { ButtonHelpModule } from '@shared/button-help/button-help.module';
import { TreoMessageModule } from '@treo/components/message';

@NgModule({
  declarations: [
    AuthComponent,
    EmailVerificationComponent,
    OnboardingComponent,
  ],
  imports: [
    SharedModule,
    AuthRoutingModule,
    MatButtonModule,
    MatIconModule,
    ButtonHelpModule,
    TreoMessageModule,
  ],
})
export class AuthModule {}
